// @flow
import React from 'react'

const Bed = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
      <g fill="none" fillRule="evenodd" stroke="#6e7b8c">
        <path d="M.5 13.5h22M.5 17.5h22" />
        <path strokeLinecap="square" d="M3.5.5h16v6h-16zM22.5 20.5v-7l-3-7M3.5 6.5l-3 7v7" />
      </g>
    </svg>
  )
}

export default Bed



// WEBPACK FOOTER //
// ./src/components/Icons/Bed.js